import cn from 'bem-cn';

import { Stack } from '../../UI';
import { CourseCardSkeleton } from '../../CourseCardSkeleton';
import { CourseCard } from '../../CourseCard/CourseCard';

import { ChallengeInfoFooterProps } from './ChallengeInfoFooter.types';
import './ChallengeInfoFooter.scss';

const b = cn('challenge-info-footer');

export const ChallengeInfoFooter = (props: ChallengeInfoFooterProps) => {
    const { courses, isCoursesLoading } = props;

    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Что-то не получается? Можем помочь</h2>
            <Stack className={b('courses')}>
                {isCoursesLoading
                    ? Array.from({ length: 2 }, (_, index) => <CourseCardSkeleton key={index} />)
                    : courses?.map(course => <CourseCard key={course.id} course={course} />)}
            </Stack>
        </Stack>
    );
};
